export const GOOGLE_APP_ID = process.env.VUE_APP_GOOGLE_APP_ID
export const YANDEX_METRICA_ID = process.env.VUE_APP_YANDEX_METRICA_ID
